import { cx } from '@emotion/css';
import { CardList } from '../list/CardList';
import styles from './relatedBlogs.module.scss';
import { Category, Post, Tag } from '@lib/wordpress.d';
import { getPostsByCategory } from '@lib/wordpress';
import { useEffect, useState } from 'react';

type Props = {
  categories: Category[];
  categoryId: number;
  styles: any;
  allTags: Tag[];
};

export const RelatedBlogs = (props: Props) => {
  const { categoryId, allTags } = props;
  const [posts, setPosts] = useState<Post[]>([]);

  const getPostByCategory = async () => {
    const records: Post[] = await getPostsByCategory(categoryId);
    setPosts(records);
  };

  useEffect(() => {
    getPostByCategory();
  }, []);

  const { categories } = props;
  const sanitizedCategories = categories.filter((category) =>
    category.name != 'Uncategorized' ? category : null,
  );
  return (
    <div className={styles.root}>
      <div className={cx(styles.container, styles.blogs_wrap_container)}>
        {
          <CardList
            styles={styles}
            posts={posts}
            categories={sanitizedCategories}
            totalPages={3}
            tags={allTags}
            page={1}
            selectedCategory={String(categoryId)}
            noPagiation={true}
            limit={3}
          />
        }
      </div>
    </div>
  );
};
